module.exports = __webpack_public_path__ + "img/NavigationDrawerBackgroundDark.895e30fe.png";